import React, { useState, useCallback } from 'react';
import Button from '@hubins/components/Button';
import __ from 'localisation';
import { useMiddleman } from '@hubins/middleman';
import { useHistory } from 'react-router-dom';
import { useNotificationContext } from '@hubins/components/NotificationContext/NotificationContext';

const DeleteProfileButton = ({ profileUuid }) => {
  const middleman = useMiddleman();

    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const { setNotification } = useNotificationContext();

    const deleteProfile = useCallback(async () => {
        if (window.confirm(__('delete_profile_confirmation'))) {
            try {
                setLoading(true);
                await middleman.promiseDelete(`/ql/crm/profile/delete/${profileUuid}`);
                setNotification({ type: 'success', message: <p>{__('profile_deleted')}</p> });
                history.push('/dashboard/profiles');
            } catch (e) {
                console.error(e.message);
                setNotification({ type: 'error', message: <p>{e.response.data.error || e.message}</p> });
                setLoading(false);
            }
        }
    }, [profileUuid]);

    return (
        <Button className="danger" icon="Bin by Streamlinehq" iconColor="white" onClick={deleteProfile} loading={loading} disabled={loading}>
            {__('delete_profile')}
        </Button>
    );
};

export default DeleteProfileButton;